import { ChannelEnum, StepsCodeEnum, StepsStatusEnum, StepsTypeEnum } from 'modules/global/typing/enums/steps.enum';
import type { Step } from 'modules/steps/types/step';

export const FIXED_STEP_NAME = {
  [StepsCodeEnum.PLANNED]: { id: 'customSteps.fixedStep.planned', defaultMessage: 'Planned' },
  [StepsCodeEnum.REMINDED]: { id: 'customSteps.fixedStep.reminded', defaultMessage: 'Reminded' },
  [StepsCodeEnum.READY]: { id: 'customSteps.fixedStep.ready', defaultMessage: 'Ready' },
  [StepsCodeEnum.FOLLOW_UP]: { id: 'customSteps.fixedStep.follow_up', defaultMessage: 'Follow-up' },
};

export const FIXED_STEP_HELP = {
  [StepsCodeEnum.PLANNED]: { id: 'customSteps.help.planned', defaultMessage: 'Automatic sending on creation' },
  [StepsCodeEnum.REMINDED]: {
    id: 'customSteps.help.reminded',
    defaultMessage: 'Automatic sending 24 hours before planned date',
  },
  [StepsCodeEnum.FOLLOW_UP]: {
    id: 'customSteps.help.followUp',
    defaultMessage: 'Automatic sending of follow-up {hours} hours after the appointment.',
  }
};

export const STEP_STATUSES = {
  [StepsStatusEnum.PRIVATE]: { id: 'page.private', defaultMessage: 'Private' },
  [StepsStatusEnum.PUBLIC]: { id: 'page.public', defaultMessage: 'Public' },
  [StepsStatusEnum.SENDABLE]: { id: 'customSteps.visibility.sendable', defaultMessage: 'Public and sendable' }
};

export const NAME_MAX_LENGTH = 15;

export const DESCRIPTION_MAX_LENGTH = 40;

export const STEP_DEFAULT_SMS = 'page.steps.details.customerDescription.defaultMessage.default';

export const ALLOWED_CHANNEL_CUSTOM_MESSAGES = [ChannelEnum.SMS, ChannelEnum.EMAIL];

export const FIXED_STEP_DEFAULT_MESSAGE: Partial<Record<StepsCodeEnum, Partial<Record<ChannelEnum, string>>>> = {
  [StepsCodeEnum.FOLLOW_UP]: {
    [ChannelEnum.SMS]: 'steps.defaults.follow_up.message.sms'
  },
  [StepsCodeEnum.READY]: {
    [ChannelEnum.SMS]: 'steps.defaults.ready.message.sms',
    [ChannelEnum.EMAIL]: 'steps.defaults.ready.message.email',
  },
  [StepsCodeEnum.PLANNED]: {
    [ChannelEnum.SMS]: 'steps.defaults.planned.message.sms',
    [ChannelEnum.EMAIL]: 'steps.defaults.planned.message.email',
  },
  [StepsCodeEnum.REMINDED]: {
    [ChannelEnum.SMS]: 'steps.defaults.reminded.message.sms',
    [ChannelEnum.EMAIL]: 'steps.defaults.reminded.message.email',
  },
};

export const NEW_STEP_KEYS = {
  new: 'new',
  newFollowUp: 'newFollowUp'
};

export const DEFAULT_STEP_PROPS = {
  languages: [],
  description: {},
  resetAssignee: false,
  type: StepsTypeEnum.DEFAULT,
  status: StepsStatusEnum.PUBLIC
};

export const DEFAULT_FOLLOW_UP_STEP_PROPS: Partial<Step> = {
  status: StepsStatusEnum.SENDABLE,
  type: StepsTypeEnum.FIXED,
  code: StepsCodeEnum.FOLLOW_UP,
  preferredCommunicationChannel: {
    channels: [ChannelEnum.EMAIL, ChannelEnum.SMS],
    targetChannelCount: 2,
  }
};
